import type { Static } from 'runtypes';
import { Literal, Record, String } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { BaseAiChatEventRuntype } from './ai-chat';
import { ClickstreamEventEnum } from 'bc-model';

const AiChatFailedEventBrowserRuntype = BaseEventRuntype.And(BaseAiChatEventRuntype).And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_ASSIST_FAILED),
    version: Literal(1),
  })
);

const AiChatFailedEventServerRuntype = AiChatFailedEventBrowserRuntype.And(CoreEventRuntype).And(
  Record({
    sessionId: String,
  })
);

type AiChatFailedBrowserEvent = Static<typeof AiChatFailedEventBrowserRuntype>;
type AiChatFailedServerEvent = Static<typeof AiChatFailedEventServerRuntype>;

const isAiChatFailedBrowserEvent = (obj: BaseEvent): obj is AiChatFailedBrowserEvent => {
  return obj.event === 'AI Assist Failed';
};

const isAiChatFailedServerEvent = (obj: BaseEvent): obj is AiChatFailedServerEvent => {
  return obj.event === 'AI Assist Failed';
};

export {
  isAiChatFailedBrowserEvent,
  isAiChatFailedServerEvent,
  AiChatFailedEventBrowserRuntype,
  AiChatFailedEventServerRuntype,
  type AiChatFailedBrowserEvent,
  type AiChatFailedServerEvent,
};
